<template>
  <div style="text-align: center;">
    <h1 style="
    font-size: 2.5rem;
    margin-bottom: 0.5rem;
    font-family: 'Basic',Helvetica,Arial,Lucida,sans-serif;
    font-weight: 500;
    line-height: 1.2;
    color: inherit;
    display: block;">Modificar Senha</h1>
    <input type="text"      data-cy="token"     v-model="token" style="display:none">
    <input type="text"      data-cy="email"     v-model="email" style="display:none">
    <input type="password"      data-cy="password"  v-model="password" placeholder="Senha"
      style="
        padding: 4px;
        border: 2px solid #55006D;
        font-family: 'Basic',Helvetica,Arial,Lucida,sans-serif;
        margin-top: 5px;
        margin-right: 5px;
        margin-left: 5px;
        margin-bottom: 5px;
        font-family: lato;
        font-size: large;
        line-height: inherit;
        width: 400px;
        height: 50px;
        font-style: normal;
        font-weight: 400;
        color: #55006D;
        border-radius: 4px;
        box-sizing: border-box;
        "
      ><br>
    <input type="password"  data-cy="passwordConfirmation"  v-model="passwordConfirmation" placeholder="Confirmação de senha"
      style="
        padding: 4px;
        border: 2px solid #55006D;
        font-family: 'Basic',Helvetica,Arial,Lucida,sans-serif;
        margin-top: 5px;
        margin-right: 5px;
        margin-left: 5px;
        margin-bottom: 5px;
        font-family: lato;
        font-size: large;
        line-height: inherit;
        width: 400px;
        height: 50px;
        font-style: normal;
        font-weight: 400;
        color: #55006D;
        border-radius: 4px;
        box-sizing: border-box;
        "
      ><br>
    <button @click="resetPassword" data-cy="entrar" style="
    color: #FFFFFF;
    font-family: lato;
    font-style: normal;
    font-weight: 400;
    background-color: #55006D;
    width: 400px;
    font-variant: normal;
    font-size: large;
    border-radius: 4px;
    line-height: normal;
    text-align: center;
    margin-top: 20px;
    border-color: #55006D;">Alterar senha</button>
    <div class="new-form-loading" v-if="this.loading"></div>
  </div>
</template>

<script>
import { setupAxios } from '../../setupAxios';
import { resetPassword } from '../../apiClient';

export default {
  name: 'ForgotPassword',
  data: function () {
    return {
      email: '',
      token: '',
      password: '',
      passwordConfirmation: '',
      loading: false
    };
  },
  mounted () {
    this.axios = setupAxios();
    this.email = this.$route.query.email;
    this.token = this.$route.query.token;
  },
  methods: {
    async resetPassword () {
      this.loading = true;
      const data = {
        email: this.email,
        token: this.token,
        password: this.password,
        passwordConfirmation: this.passwordConfirmation
      };

      const res = await resetPassword(this.axios, data);
      this.loading = false;
      if (res && res.status === 200) {
        alert("A senha foi alterada!");
        this.$router.push({ name: 'login_donator' });
      }
    }
  }
};
</script>
